export default __webpack_public_path__ + "static/media/arrow.762d5249.svg";